var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconBed = function SvgIconBed(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M2.5 4.5a1 1 0 0 0-2 0v15a1 1 0 1 0 2 0v-2.75h19v2.75a1 1 0 1 0 2 0v-9a4 4 0 0 0-4-4h-17zm0 4v6.25h6.25V8.5zm19 6.25H10.75V8.5h8.75a2 2 0 0 1 2 2z",
    clipRule: "evenodd"
  })));
};
export default SvgIconBed;